import _set from 'lodash/set';
import { IImageEffect } from './interface/image-effect.interface';
import { IShapeModel } from '../../Interface/shape-model.interface';
import { IPictureModel } from '../../Interface/picture-model.interface';

// 迁移自picture-model.ts
export default class ImageEffect implements IImageEffect {
    private model: IShapeModel | IPictureModel;
    public constructor(model: IShapeModel | IPictureModel) {
        this.model = model;
    }

    /**
     * 图片颜色/校正
     */
    public handleImageEffect(values, options): void {
        const blip = {};
        Object.keys(values).forEach((key) => {
            const value = values[key];
            if (options?.onlyChangeUI) {
                _set(this.model, `props.style.image.${key}`, value);
                this.model.previewChange += 1; // 触发ui刷新
            }
            blip[key] = value;
        });
        if (!options?.onlyChangeUI) {
            const data = { style: {
                image: Object.assign({}, this.model.props.style.image, blip),
            } };
            this.model.updateProps(data);
        }
    }
}
